import { usersApi } from '@frontend/lib/api';
import { useQuery } from '@tanstack/react-query';

export function useCurrentUser() {
  const query = useQuery({
    queryKey: ['user', 'me'],
    queryFn: () => usersApi.me(),
  });

  return {
    user: query.data ?? null,
    isAdmin: query.data?.role === 'admin',
    isLoading: query.isLoading,
  };
}
